import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { faqQueries } from '@/services/faq/faq.queries';
import { useSearch } from '@tanstack/react-router';

export const useComplaints = () => {
  const { page, sort, fetch, q } = useSearch({ from: '/(app)/faq/complaints/' });
  const { data, isLoading } = useQuery({
    ...faqQueries.complaints({ fetch: fetch, row: page, search: q ?? '' }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { complaints: data?.data || [], pagination: data?.meta?.pagination ?? defaultMeta, loading: isLoading };
};
